import React, {useEffect} from "react";
import KamoHeader from "./KamoHeader";
import Footer from "../../layout/Footer";
import KamolacFooter from "./KamolacFooter";

const EcoFriendlyWaterBased = () => {
  
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
     
  return (
<>
    <KamoHeader
/>   
 <div className="water">

      {/* HERO */}
      <section className="hero">
       <img src={process.env.PUBLIC_URL + '/images/products/new/3.png' } alt="" />
        <div className="hero-content">
          <h1>Water-Based Wood Finishes</h1>
          <p style={{color:'#fff'}}>
            The modern standard for sustainable luxury, Water-Based Wood Finishes offer a professional-grade protective coat without the harsh odors or environmental impact of traditional solvent-based products.
          </p>
        </div>
      </section>

      {/* INTRO SPLIT */}
      <section className="split">
        <div className="text">
          <h2>The Benefits of Water-Based Finishes</h2>
          <p>
            Our water-based line is engineered for the conscious homeowner and the high-end designer alike. By utilizing advanced resin technology, we provide a finish that is as tough as it is transparent.
          </p>

          <ul className="waterlist">
            <li><b>Eco-Friendly: </b>Low VOC (Volatile Organic Compounds) for better indoor air quality.</li>
            <li><b>Crystal Clear: </b> Unlike oil-based finishes that "amber" or turn orange over time, our water-based formula stays Water-White.</li>
            <li><b>Quick Drying: </b> Dry to the touch in as little as 30 minutes, allowing for multiple coats in a single day.</li>
            <li><b>Low Odor: </b> Ideal for occupied homes, hospitals, and hotels where chemical smells are a concern.</li>
          </ul>
        </div>

        <div className="image">
          <img src={process.env.PUBLIC_URL + '/images/products/new/6.png' } alt="" />
        </div>
      </section>

      {/* IMAGE GRID */}
      <section className="grid">
        <img src={process.env.PUBLIC_URL + '/images/products/new/2.png' } alt="" />
        <img src={process.env.PUBLIC_URL + '/images/products/new/5.png' } alt="" />
        <img src={process.env.PUBLIC_URL + '/images/products/new/7.png' } alt="" />
      </section>

      {/* SHEEN SECTION */}
      <section className="container">
        <h2>Choose Your Sheen Level</h2>
        <p>
          Available in three distinct levels of reflection to suit your interior style:
        </p>

        <div className="cards">

          <div className="card">
            <img src={process.env.PUBLIC_URL + '/images/products/new/3.png' } alt="" />
            <div className="content">
              <h3>Ultra-Matt: The Raw Wood Look</h3>
              <p>Perfect for those who want the wood to look "unfinished" but stay fully protected.</p>
              <p><strong>Appearance:</strong> Flat, non-reflective finish (0–5% sheen).</p>
              <p><strong>Best For:</strong> Rustic furniture, driftwood styles, and modern "invisible" coatings.</p>
              <p><strong>Advantage:</strong> Extremely forgiving—it hides dust and minor scratches effortlessly.</p>
            </div>
          </div>

          <div className="card">
            <img src={process.env.PUBLIC_URL + '/images/products/new/3.png' } alt="" />
            <div className="content">
              <h3>Satin (Semi-Gloss): The Sophisticated Glow</h3>
              <p>The most popular choice for high-end cabinetry and residential furniture.</p>
              <p><strong>Appearance:</strong> A soft, candlelit luster (30–45% sheen).</p>
              <p><strong>Best For:</strong> Kitchen cabinets, dining tables, and children’s furniture.</p>
              <p><strong>Advantage:</strong> Offers a smooth, "silky" feel that is incredibly easy to wipe clean.</p>
            </div>
          </div>

          <div className="card">
            <img src={process.env.PUBLIC_URL + '/images/products/new/3.png' } alt="" />
            <div className="content">
              <h3>High Gloss: The Polished Mirror</h3>
              <p>For a high-impact, contemporary look that mimics the depth of liquid glass.</p>
              <p><strong>Appearance:</strong> High reflectivity and maximum depth (85%+ sheen).</p>
              <p><strong>Best For:</strong> Statement accent walls, musical instruments, and luxury retail displays.</p>
              <p><strong>Advantage:</strong> Exceptionally durable and moisture-resistant; brings out the deepest tones in dark wood.</p>
            </div>
          </div>

        </div>
      </section>

      {/* OVERLAY FEATURE */}
      <section className="overlay">
        <img src={process.env.PUBLIC_URL + '/images/products/new/3.png' } alt="" />
        <div className="box">
          <h2>Technical Features & Maintenance</h2>
          <ul className="waterlist">
            <li><b>Durability:</b> Scuff-resistant and non-flammable.</li>
            <li><b>Ease of Use:</b> Easy soap-and-water cleanup for tools and brushes.</li>
            <li><b>Versatility:</b> Can be applied over stained or bare wood without affecting the color profile.</li>
    
          </ul>
          <p><b>Professional Tip:</b> Water-based finishes are the #1 choice for light-colored woods like White Oak, Pine, and Birch to prevent them from turning yellow as they age.</p>
        </div>
      </section>

      {/* TABLE */}
      <section className="container">
        <h2>Finish Comparison at a Glance</h2>

        <div className="table">
          <table>
            <thead>
              <tr>
                <th>Feature</th>
                <th>Water-Based</th>
                <th>Traditional PU/Oil</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Odor</td>
                <td>Very Low</td>
                <td>Strong / Chemical</td>
              </tr>
              <tr>
                <td>Color Shift</td>
                <td>None (Stays Clear)</td>
                <td>Yellows/Ambers over time</td>
              </tr>
              <tr>
                <td>Cleanup</td>
                <td>Soap & Water</td>
                <td>Mineral Spirits/Thinners</td>
              </tr>
              <tr>
                <td>Dry Time</td>
                <td>1–2 Hours</td>
                <td>6–12 Hours</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>

    </div>

    <KamolacFooter />
    </>
  );
};

export default EcoFriendlyWaterBased;